import { Box } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'

import { Navbar } from '@/components'
import { ActivityBar } from '@/components/ActivityBar'
import { LeftPanelModeProvider } from '@/components/LeftPanelMode'
import { ROUTES } from '@/constants'
import { TreePanelProvider } from '@/pages/User/pages/Home/components/TreePanel/TreePanelContext'

/** Routes reachable from activity-bar icons — keep the rail visible so users can switch. */
const ACTIVITY_BAR_ROUTES = [
	ROUTES.PROJECT_VIEW,
	ROUTES.DATA_CATALOG,
	ROUTES.REPORTS,
	ROUTES.ONTOLOGY,
	ROUTES.BRANCHES,
	ROUTES.MERGE_REQUESTS,
	ROUTES.RELEASES,
	ROUTES.DEPLOYMENT_DASHBOARD,
	ROUTES.DEPLOYMENT_PACKAGES,
	ROUTES.SYSTEM_SETTINGS,
	ROUTES.AI_AGENTS,
	ROUTES.SETTINGS,
] as const

export const MainLayout = () => {
	const location = useLocation()
	const showActivityBar = ACTIVITY_BAR_ROUTES.some((route) =>
		route === ROUTES.PROJECT_VIEW
			? location.pathname === route
			: location.pathname.startsWith(route),
	)

	return (
		<LeftPanelModeProvider>
			<TreePanelProvider>
				<Navbar />
				<Box
					sx={{
						display: 'flex',
						minHeight: 0,
						flex: 1,
						overflow: 'hidden',
					}}
				>
					{showActivityBar && <ActivityBar />}
					<Box
						sx={{
							display: 'flex',
							height: '100%',
							minHeight: 0,
							minWidth: 0,
							flex: 1,
							flexDirection: 'column',
							overflow: 'hidden',
						}}
					>
						<Outlet />
					</Box>
				</Box>
			</TreePanelProvider>
		</LeftPanelModeProvider>
	)
}
